import request from '@/utils/request';
import Vue from 'vue';
//查询电子表单列表
export function electronicFormQuery (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/electronicForm/query`,
      data:params
    });
}
// 创建电子表单
export function electronicFormCreate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/electronicForm/create`,
      data:params
    });
}
//删除电子表单
export function electronicFormDelete (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/electronicForm/delete/${params}`
    });
}
//查询所有的标签 
export function electronicFormGetAllLabels () {
    return request({
      method: 'get',
      url: `${Vue.prototype.$conf.visaService}/electronicForm/getAllLabels`
    });
}
//更新电子表单 
export function electronicFormUpdate(params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/electronicForm/update`,
      data:params
    });
}

//创建电子表单选项 
export function electronicFormItemCreate(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/electronicFormItem/create`,
    data:params
  });
}
//删除电子表单选项
export function electronicFormItemDelete (params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/electronicFormItem/delete/${params}`
  });
}
//查询电子表单选项 
export function electronicFormItemQuery(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/electronicFormItem/query`,
    data:params
  });
}
//更新电子表单选项 
export function electronicFormItemUpdate(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/electronicFormItem/update`,
    data:params
  });
}
//删除电子表单项 /electronicFormItemDataSource/delete/{dataSourceBid}
export function electronicFormItemDataSourceDelete(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/electronicFormItemDataSource/delete/${params}`,
  });
}